import {
  AWAITABLE_TRIGGERS,
  PhraseTriggers,
  TriggerActions,
} from '../../constants/constants';

const LEGACY_TRIGGERS = new Set(Object.values(PhraseTriggers));
const STRUCTURED_TRIGGER_ACTIONS = new Set(Object.values(TriggerActions));

function parseTriggerString(raw) {
  const colonIdx = raw.indexOf(':');
  if (colonIdx !== -1) {
    const action = raw.slice(0, colonIdx).trim().toLowerCase();
    const targets = raw
      .slice(colonIdx + 1)
      .split(',')
      .map((target) => target.trim())
      .filter(Boolean);
    return { trigger: raw, triggerAction: action, triggerData: targets };
  }
  return { trigger: raw, triggerAction: raw, triggerData: [] };
}

function isRecognizedTrigger({ trigger, triggerAction }) {
  const isLegacyTrigger =
    LEGACY_TRIGGERS.has(trigger) || AWAITABLE_TRIGGERS.includes(trigger);
  const isStructuredTrigger =
    trigger.includes(':') && STRUCTURED_TRIGGER_ACTIONS.has(triggerAction);

  return isLegacyTrigger || isStructuredTrigger;
}

export function parsePhrasesWithTriggers(verbalInstructions) {
  const regex = /\[([^\]]+)\]/g;
  let match;
  let lastIndex = 0;
  const phrases = [];
  let currentPhrase = '';

  while ((match = regex.exec(verbalInstructions)) !== null) {
    const [, rawTrigger] = match;
    const textBeforeTrigger = verbalInstructions.slice(lastIndex, match.index);
    const parsed = parseTriggerString(rawTrigger);

    // Vocabulary content also uses brackets for emphasis. Only consume brackets
    // when their contents match Lexa's documented trigger grammar.
    if (!isRecognizedTrigger(parsed)) {
      currentPhrase += textBeforeTrigger + rawTrigger;
      lastIndex = regex.lastIndex;
      continue;
    }

    currentPhrase += textBeforeTrigger;
    if (currentPhrase.trim()) {
      phrases.push({
        text: currentPhrase.trim(),
        trigger: null,
        triggerAction: null,
        triggerData: [],
      });
      currentPhrase = '';
    }

    if (parsed.trigger === PhraseTriggers.Split) {
      if (phrases.length > 0) {
        const previousPhrase = phrases[phrases.length - 1];
        if (previousPhrase.text && !previousPhrase.trigger) {
          previousPhrase.pauseAfterSpeech = true;
        }
      }
    } else {
      phrases.push({ text: '', ...parsed });
    }

    lastIndex = regex.lastIndex;
  }

  currentPhrase += verbalInstructions.slice(lastIndex);
  if (currentPhrase.trim()) {
    phrases.push({
      text: currentPhrase.trim(),
      trigger: null,
      triggerAction: null,
      triggerData: [],
    });
  }

  return phrases;
}
